import {
  WORK_ORDERS_DETAILS_CREATE_QUOTE_MODAL_CLOSE,
  WORK_ORDERS_DETAILS_CREATE_QUOTE_MODAL_FORM_EDIT,
  WORK_ORDERS_DETAILS_CREATE_QUOTE_MODAL_FORM_INVALID,
  WORK_ORDERS_DETAILS_CREATE_QUOTE_MODAL_FORM_VALID,
  WORK_ORDERS_DETAILS_CREATE_QUOTE_MODAL_FORM_VALUE_UPDATE,
  WORK_ORDERS_DETAILS_CREATE_QUOTE_MODAL_SHOW,
  WORK_ORDERS_DETAILS_CREATE_QUOTE_STATE_SET,
  WORK_ORDERS_DETAILS_CREATE_QUOTE_VALIDATION_MESSAGE_SET,
  WORK_ORDERS_DETAILS_REVIEW_QUOTE_MODAL_SHOW,
  WORK_ORDERS_DETAILS_CREATE_QUOTES_MODAL_SHOW_SET,
  WORK_ORDERS_DETAILS_CREATE_QUOTES_STATE_SET,
  WORK_ORDERS_DETAILS_CREATE_QUOTES_FORM_SET,
} from 'actions/admin/work-orders/action-types';
import { quotesApi } from 'services/api/quotes-api';
import { showErrorMessage } from 'actions/messages';
import {
  addQuote,
  updateQuotes,
} from 'actions/admin/work-orders/details/details';
import { workOrdersApi } from 'services/api/work-orders-api';

export function continueCreateQuotes(values) {
  return (dispatch) => {
    dispatch(setCreateQuotesForm(values));
    dispatch(setCreateQuotesModalState('review'));
  };
}

export function continueWithFormRequest(form) {
  return (dispatch) => {
    let invalidAttributes = Object.keys(form)
      .filter((formKey) => formKey !== 'materialLeadDays')
      .filter(
        (key) =>
          key !== 'description' &&
          (form[key].value === '' || form[key].value === null)
      ); // Description is not required

    if (invalidAttributes.length > 0) {
      dispatch(invalidForm(invalidAttributes));
      dispatch(setValidationMessage('The outlined inputs should be added'));
    } else {
      dispatch(validForm());
    }
  };
}

export function closeCreateQuoteModal() {
  return {
    type: WORK_ORDERS_DETAILS_CREATE_QUOTE_MODAL_CLOSE,
  };
}

export function editForm() {
  return {
    type: WORK_ORDERS_DETAILS_CREATE_QUOTE_MODAL_FORM_EDIT,
  };
}

export function invalidForm(invalidAttributes) {
  return {
    type: WORK_ORDERS_DETAILS_CREATE_QUOTE_MODAL_FORM_INVALID,
    payload: invalidAttributes,
  };
}

function setCreateQuotesForm(values) {
  return {
    type: WORK_ORDERS_DETAILS_CREATE_QUOTES_FORM_SET,
    payload: values,
  };
}

export function setCreateQuotesModalState(state) {
  return {
    type: WORK_ORDERS_DETAILS_CREATE_QUOTES_STATE_SET,
    payload: state,
  };
}

export function setModalState(state) {
  return {
    type: WORK_ORDERS_DETAILS_CREATE_QUOTE_STATE_SET,
    payload: state,
  };
}

export function setShowCreateQuotesModal(value) {
  return {
    type: WORK_ORDERS_DETAILS_CREATE_QUOTES_MODAL_SHOW_SET,
    payload: value,
  };
}

export function setValidationMessage(value) {
  return {
    type: WORK_ORDERS_DETAILS_CREATE_QUOTE_VALIDATION_MESSAGE_SET,
    payload: value,
  };
}

export function showCreateQuoteModal() {
  return {
    type: WORK_ORDERS_DETAILS_CREATE_QUOTE_MODAL_SHOW,
  };
}

export function showReviewQuoteModal(quote) {
  return {
    type: WORK_ORDERS_DETAILS_REVIEW_QUOTE_MODAL_SHOW,
    payload: quote,
  };
}

export function createQuoteRequest(form) {
  return (dispatch) => {
    const values = {};
    Object.keys(form).forEach((key) => {
      values[key] = form[key].value;
    });

    return quotesApi.createQuote(values).then((response) => {
      if (response.ok) {
        dispatch(addQuote(response.quote));
        dispatch(setModalState('confirmation'));
      } else {
        dispatch(showErrorMessage(response.errors));
      }
    });
  };
}

export function submitQuoteRequest(quoteId, form) {
  return (dispatch) => {
    const values = {};
    Object.keys(form).forEach((key) => {
      values[key] = form[key].value;
    });

    return quotesApi.submitQuote(quoteId, values).then((response) => {
      if (response.ok) {
        dispatch(updateQuotes([response.quote]));
        dispatch(setModalState('confirmation'));
      } else {
        dispatch(showErrorMessage(response.errors));
      }
    });
  };
}

export function submitQuotes(workOrderId, contractorId, values) {
  return (dispatch) => {
    return workOrdersApi
      .submitQuotes(workOrderId, contractorId, values)
      .then((response) => {
        if (response.ok) {
          dispatch(
            updateQuotes(
              response.quotes.map((quote) => {
                // Remove work_order property from the new object
                const { work_order, ...newQuote } = quote;
                return newQuote;
              })
            )
          );
          dispatch(setCreateQuotesModalState('confirmation'));
        } else {
          dispatch(showErrorMessage(response.errors));
        }
      });
  };
}

export function respondCounterQuoteRequest(quoteId, action) {
  return (dispatch) => {
    return quotesApi.respondCounterQuote(quoteId, action).then((response) => {
      if (response.ok) {
        dispatch(updateQuotes([response.quote]));
        dispatch(setModalState('confirmation'));
      } else {
        dispatch(showErrorMessage(response.errors));
      }
    });
  };
}

export function updateFormValue(value, attribute) {
  return {
    type: WORK_ORDERS_DETAILS_CREATE_QUOTE_MODAL_FORM_VALUE_UPDATE,
    payload: { value, attribute },
  };
}

export function validForm() {
  return {
    type: WORK_ORDERS_DETAILS_CREATE_QUOTE_MODAL_FORM_VALID,
  };
}



// WEBPACK FOOTER //
// ./src/actions/admin/work-orders/details/create-quote.js